module.exports = __webpack_public_path__ + "static/media/faq.97a27ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/faq.png
// module id = 926
// module chunks = 0